export const FACE_SIMILARITY_THRESHOLD = 90.0;

export const MAX_RETRIES = 3;

export const NAME_CHANGE_DOCUMENTATION_ID_TYPES = [
  'name_change_documentation',
  'marriage_certificate',
];

// Overall ID upload status values
export const IDV_OVERALL_STATUS = {
  VERIFIED: 'verified',
  NEEDS_REVIEW: 'needs_review',
  REJECTED: 'rejected',
  FAILED: 'failed',
  NOT_APPLICABLE: 'not_applicable',
};

// Display configuration for ID upload statuses
export const IDV_OVERALL_STATUS_DISPLAY = {
  [IDV_OVERALL_STATUS.VERIFIED]: { title: 'Verified', color: 'success' },
  [IDV_OVERALL_STATUS.NEEDS_REVIEW]: { title: 'Needs Review', color: 'warning' },
  [IDV_OVERALL_STATUS.REJECTED]: { title: 'Rejected', color: 'error' },
  [IDV_OVERALL_STATUS.FAILED]: { title: 'Failed', color: 'error' },
  [IDV_OVERALL_STATUS.NOT_APPLICABLE]: { title: 'Reference Only', color: 'info' },
};

// Sub-status values for individual ID verification checks
export const IDV_SUB_STATUS = {
  PASSED: 'passed',
  PENDING: 'pending',
  FAILED: 'failed',
  NOT_APPLICABLE: 'not_applicable',
};

// Display configuration for sub-statuses (passed, pending, failed)
export const IDV_SUB_STATUS_DISPLAY = {
  [IDV_SUB_STATUS.PASSED]: { title: 'Passed', color: 'success' },
  [IDV_SUB_STATUS.PENDING]: { title: 'Pending', color: 'warning' },
  [IDV_SUB_STATUS.FAILED]: { title: 'Failed', color: 'error' },
  [IDV_SUB_STATUS.NOT_APPLICABLE]: { title: 'Not Applicable', color: 'neutral' },
};

export const IDV_UPDATABLE_STATUS_FIELDS = [
  'authentication_status',
  'id_type_match_status',
  'country_match_status',
  'expiry_tolerance_status',
  'name_match_status',
];
